import { render, staticRenderFns } from "./TopicPage.vue?vue&type=template&id=e3368f92&scoped=true&"
import script from "./TopicPage.vue?vue&type=script&lang=js&"
export * from "./TopicPage.vue?vue&type=script&lang=js&"
import style0 from "./TopicPage.vue?vue&type=style&index=0&id=e3368f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3368f92",
  null
  
)

export default component.exports